export const PRICE_CURRENCY_CONTROL_ID = 'ticketing-ticket-price-currency';
export const PRICE_CURRENCY_SUFFIX = 'USD';
